import React from "react";
import { Link } from "gatsby";
import * as b from "../bootstrap.module.css";
import Thumbnail from "../thumbnail";
import productData from "../../utils/product-data";
import Out from "../../components/out-product";
import Icon from "../../components/icon.tsx";
import ProductCheckboxComparison from "../product-comparison-checkbox";
import useMedia from "../../hooks/useMedia";
import Translate from "../translate";

const RankingItem = ({ item,i,ranking,settings }) => {
  const isMobRes = useMedia(['(max-width: 992px)'], [true], false);
  const newData = productData(item);

  if (!newData.visible) {
    return null;
  }

  return ranking === "item" ? (
    <div className={` blog-ranking-item-wrapper ${b.mb3} ${b.colMd4} ${i === 1 ? b.orderLg2 : i === 2 ? b.orderLg1 + ` ${b.mtLg5}` : b.orderLg3 + ` ${b.mtLg5}` }` }>
      <div className={["blog-ranking-item"].join(' ')}>
        {newData && (
          <>
            <div className={[b.textCenter, b.mb3].join(" ")}>
              <div className={[b.dBlock, "ranking-box-text",'blackToWhite'].join(" ")}>
                {i === 1 ? <img src="/assets/Ranking-1.svg" width="216" height="157"/> : ''}
                {i === 2 ? <img src="/assets/Ranking-2.svg" width="146" height="117"/> : ''}
                {i === 3 ?<img src="/assets/Ranking-3.svg" width="146" height="117"/> : ''}
              </div>
            </div>
            <div className={[b.dFlex,b.justifyContentCenter,b.alignItemsCenter].join(' ')}>
              <Link className={`blog-ranking-item-image-${i} ranking-img-1 `} to={newData.url}>
                <Thumbnail image={newData.image} alt={newData.name} className="object-fit-img"/>
              </Link>
            </div>
            <Link className={`${b.btn} blog-ranking-item-btn btn-cta ${b.fontWeightNormal} ${b.textCapitalize} ${b.textWhite} ${i === 1 ? 'btn-danger' : 'btn-success' }`}
             to={newData.url}>
              <span className={[b.mr2].join(' ')}>
                <Icon color="#fff" size={20} icon="Logout" />
              </span>
              <Translate tKey="check" />
            </Link>
          </>
        )}
      </div>
    </div>
  ) : ranking === "all" ? (
    <Link to={newData.url} className={["ranking-column-item",b.row,b.alignItemsCenter,b.justifyContentBetween,b.mb3,'ranking-img-box'].join(" ")}>
      <div className={["ranking-column-num", b.colAuto,`ranking-placement-${i}-box`,b.py3,b.mr3].join(" ")}>
        <div>
          
        </div>
        <div className="ranking-placement-pl">{i}</div>
      </div>
      <div className={[b.col, b.px0].join(" ")}>
        <div className='dark-mode-image'>
          <div className='ranking-thumbnail'><Thumbnail image={newData.image} alt={newData.name}/></div>
        </div>
        <span className={["ranking-column-name",b.pt2].join(' ')}>{newData.name}</span>
      </div>
      <div className={[b.colAuto, b.orderLgLast].join(" ")}>
        <span className="ranking-column-rating">
          <Icon size={20} icon="Star" className={['icon-width',b.mr2].join(' ')} />
          <span className="ranking-column-name">{newData.rating.toFixed(1)}</span>
        </span>
      </div>
    </Link>
  ) : ranking === "404" ? (
    <Link to={newData.url} className={["ranking-column-item",b.row,b.justifyContentBetween,'ranking-img-box'].join(" ")}>
      <div className={["ranking-column-num", b.colAuto,`ranking-placement-${i}-box`,b.pb2,b.mr3].join(" ")}>
          { i === 1 ? <div><img src="/assets/icons/ranking-medal-1.svg" alt="Ranking medal 1" loading="lazy" width="41" height="40"/></div> : ''}
          { i === 2 ? <div><img src="/assets/icons/ranking-medal-2.svg" alt="Ranking medal 2" loading="lazy" width="41" height="40"/></div> : ''}
          { i === 3 ? <div><img src="/assets/icons/ranking-medal-3.svg" alt="Ranking medal 3" loading="lazy" width="41" height="40"/></div> : ''}
          <div className={[b.dFlex,b.justifyContentCenter,b.alignItemsCenter].join(' ')}>
            <span className={["blueToWhite"].join(" ")}>{i}</span>
          </div>
      </div>
      <div className={[b.col, b.px0].join(" ")}>
        <div className={['dark-mode-image','ranking-column-img404',b.dFlex,b.alignItemsCenter,b.justifyContentCenter].join(' ')}>
          <div className='ranking-thumbnail'><Thumbnail image={newData.image} alt={newData.name}/></div>
        </div>
      </div>
      <div className={[b.colAuto, b.orderLgLast].join(" ")}>
        <span className={["ranking-column-rating404",b.textCenter].join(' ')}>
          <Icon size={20} icon="Star" className='icon-width' />
          <span className="ranking-column-name">{newData.rating.toFixed(1)}</span>
        </span>
      </div>
    </Link>
  ) : (
    <div className={["product-box",'rangings', `ranking-products-${i}`, b.p3].join(' ')} id={`position-${i}`}>
      <div className={["product-box-dGrid"].join(' ')}>
        <div className={["product-box-n","ranking-column-num",`ranking-placement-${i}-box`].join(' ')}>
          { i === 1 ? <div className={[b.order2,b.orderLg1].join(' ')}><img src="/assets/icons/ranking-medal-1.svg" alt="Ranking medal 1" loading="lazy" width="30" height="30"/></div> : ''}
          { i === 2 ? <div className={[b.order2,b.orderLg1].join(' ')}><img src="/assets/icons/ranking-medal-2.svg" alt="Ranking medal 2" loading="lazy" width="30" height="30"/></div> : ''}
          { i === 3 ? <div className={[b.order2,b.orderLg1].join(' ')}><img src="/assets/icons/ranking-medal-3.svg" alt="Ranking medal 3" loading="lazy" width="30" height="30"/></div> : ''}
          {i > 3 &&(<div className={[b.dFlex,b.justifyContentCenter,b.alignItemsCenter,b.orderLg2,b.order1,b.mr2,b.mrLg0].join(' ')}>
            <span className={["blueToWhite",b.textCenter,b.mb0,'font-size-20'].join(" ")}>{i}</span>
          </div>)}
        </div>
      {!isMobRes ? (
        <div className={["product-box-h",b.dFlex].join(' ')}>
          <Link to={newData.url} className={[b.mr4,'tp-name',b.dFlex, b.justifyContentBetween, b.alignItemsCenter].join(' ')}><span>{newData.name}</span></Link>
          <div className={["firm-row-likes-wrapper", "product-box-l", 'main-firm-likes'].join(" ")}>
            <div className="firm-row-likes">
              <div className={[b.dFlex,b.px2,b.justifyContentCenter,b.mb1].join(" ")}>
                <div className={["stars-container", b.mr2].join(" ")}>
                  <div className="star-box" style={{ width: ` ${newData.rating * 20}% ` }}>
                    <Icon size={16} icon="Star" className={b.mr1} />
                    <Icon size={16} icon="Star" className={b.mr1} />
                    <Icon size={16} icon="Star" className={b.mr1} />
                    <Icon size={16} icon="Star" className={b.mr1} />
                    <Icon size={16} icon="Star" />
                  </div>
                  <div className="empty-star-box">
                    <Icon size={16} icon="Empty-star" className={b.mr1} />
                    <Icon size={16} icon="Empty-star" className={b.mr1} />
                    <Icon size={16} icon="Empty-star" className={b.mr1} />
                    <Icon size={16} icon="Empty-star" className={b.mr1} />
                    <Icon size={16} icon="Empty-star" />
                  </div>
                </div>
                <p className={[b.mb0, "blackToWhite"].join(" ")}>
                  {newData.rating.toFixed(1)}
                </p>
              </div>
            </div>
          </div>
        </div>) :(
        <>
          <Link to={newData.url} className="product-box-h"><span> {newData.name}</span></Link>
          <div className={["firm-row-likes-wrapper", "product-box-l", b.mr3,'main-firm-likes'].join(" ")}>
            <div className={["firm-row-likes",b.dFlex,b.px2,b.justifyContentCenter,b.mb1].join(" ")}>
              <div className={["stars-container", b.mr2].join(" ")}>
                <div className="star-box" style={{ width: ` ${newData.rating * 20}% ` }}>
                  <Icon size={16} icon="Star" className={b.mr1} />
                  <Icon size={16} icon="Star" className={b.mr1} />
                  <Icon size={16} icon="Star" className={b.mr1} />
                  <Icon size={16} icon="Star" className={b.mr1} />
                  <Icon size={16} icon="Star" />
                </div>
                <div className="empty-star-box">
                  <Icon size={16} icon="Empty-star" className={b.mr1} />
                  <Icon size={16} icon="Empty-star" className={b.mr1} />
                  <Icon size={16} icon="Empty-star" className={b.mr1} />
                  <Icon size={16} icon="Empty-star" className={b.mr1} />
                  <Icon size={16} icon="Empty-star" />
                </div>
              </div>
              <p className={[b.mb0, "blackToWhite"].join(" ")}>
                {newData.rating.toFixed(1)}
              </p>
            </div>
          </div>
        </>)}

        <div className={["product-box-img-box","product-box-p","dark-mode-image",b.mt0,b.pt2].join(" ")}>
          <Link to={newData.url}><Thumbnail image={newData.image} alt={newData.name} /></Link>
        </div>
        {!isMobRes ? (
          <div className={["product-box-i",b.dFlex,"product-box-mobile-text"].join(" ")}>
            {
              newData?.content?.map(([name, value], i) => (
                <div key={i} className={["product-box-grid-mr","product-mobile-text",b.ml3].join(" ")}>
                  <p className={["product-box-fs", b.mb0, b.pt2].join(" ")}>{name}</p>
                  <p className={["product-box-fs2", b.mb0].join(" ")}>{value}</p>
              </div>
              ))
            }
          </div>
        ) : (
          <div className={["product-box-i",b.dFlex,"product-box-mobile-text",b.mt2].join(" ")}>
            <div className='mb-pr1'>
              {
                newData?.content?.map(([name, value], i) => (
                  <div className={["product-box-grid-mr","product-mobile-text",b.mt1].join(" ")} key={i}>
                    <p className={["product-box-fs", b.mb0, b.pt2].join(" ")}>
                      {name}
                    </p>
                    <p className={["product-mobile-fs2", b.mb0].join(" ")}>
                      {value}
                    </p>
                  </div>
                ))
              }
            </div>
          </div>
        )}
        <div className={[b.colLg,b.dFlex,b.mr0,"product-box-b","product-box-b-pl",b.px0].join(" ")}>
          <div className={["product-box-buttons","product-box-mobile-buttons",'button-256'].join(" ")}>
            {newData.productType === "cards" && <Out className={[b.btn,"btn-success","btn-normal",b.mt1,b.mb0,b.fontWeightNormal,'ranking-products-button'].join(" ")} item={item} defaultDescription="Put on card" defaultIcon="Taking-money"/>}
            {newData.productType === "firm" && <Out className={[b.btn,"btn-success","btn-normal",b.mt1,b.mb0,b.fontWeightNormal,'ranking-products-button'].join(" ")} item={item} defaultDescription="Apply" defaultIcon="Taking-money"/>}
            {newData.productType === "credits" && <Out className={[b.btn,"btn-success","btn-normal",b.mt1,b.mb0,b.fontWeightNormal,'ranking-products-button'].join(" ")} item={item} defaultDescription="Apply credit" defaultIcon="Taking-money"/>}
            {newData.productType === "accounts" && <Out className={[b.btn,"btn-success","btn-normal",b.mt1,b.mb0,b.fontWeightNormal,'ranking-products-button'].join(" ")} item={item} defaultDescription="Create account" defaultIcon="Taking-money" />}
        
            <span className={["product-box-comparison-box","btn-hidden",b.w100,b.mt2,'ranking-comparison'].join(" ")}>
              {settings?.types && settings?.subtypes && (
                <ProductCheckboxComparison item={item} settings={settings} key={item.url}/>
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RankingItem